import { ICON__paste_solid } from '@/assets/icons_fa';
import { HOOK_IMAGE__paste_from_clipboard } from '@/hooks/image/HOOK_IMAGE__paste_from_clipboard';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { CONTEXT_MENU_ITEM__field_base } from '@/pages/page_generation/sidebar/_base/context_menu/_base/CONTEXT_MENU_ITEM__field_base';
import { FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph_list } from '@/utils/_methods/FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph_list';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { ENUM__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';

interface PROPS {
  field: FIELD__list_image_asset;
}

export function CONTEXT_MENU_ITEM__image__paste_from_clipboard_to_field_list({ field }: PROPS) {
  /*
   *
   */

  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { image_data_from_clipboard } = HOOK_IMAGE__paste_from_clipboard();

  let allowed_categories = [ENUM__image_asset_category.IMAGE, ENUM__image_asset_category.ANY];

  /*
   *
   */

  async function onClick() {
    if (field.items.length >= CONSTANTS__shared.IP_ADAPTER_IMAGES_LIMIT) return;

    await FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph_list([image_data_from_clipboard], field);
  }

  /*
   *
   */

  if (image_data_from_clipboard.is_stub()) return null;
  if (field.items.length >= CONSTANTS__shared.IP_ADAPTER_IMAGES_LIMIT) return null;
  if (!allowed_categories.includes(field.category)) return null;

  return <CONTEXT_MENU_ITEM__field_base disabled={g_general__ui_disabled} Icon={ICON__paste_solid} text={'Paste'} on_click={onClick} />;
}
